// Constructor
function VimeoVideoPlayer(app, $container) {
  this.app = app;
  this.playerID = $container.attr("id");

  this.player = false;
  // this.YoutubeReady = false;
  this.playerReady = false;

  this.playerRatio = 16 / 9;

  // this.currentVideoID = "";

  this.timeline = false;

  // NOTE: Vimeo player needs to be created with an ID so we cannot initialize it now. It will be initialized on first video playing.
  this.init();

  $(window).off("resize", $.proxy(this.resize, this)).on("resize", $.proxy(this.resize, this));
  this.resize();

  // Call the deffered onYouTubeIframeAPIReady event
  // YTdeferred.done($.proxy(this.onYouTubeIframeAPIReady, this));
}

VimeoVideoPlayer.prototype.init = function () {

  this.playerReady = true;

  $("#" + this.playerID).addClass("vimeo");
  $("#video-player-close").off("click").on("click", $.proxy(this.hidePlayer, this));

}

VimeoVideoPlayer.prototype.loadVideo = function (id, callback) {

  if (!this.playerReady) {
    console.warn("Player is not ready yet.");
    return;
  }

  console.log(id);
  if (typeof id === "undefined" || id == "") {
    console.warn("Video ID cannot be empty");
    return;
  }

  // Hide main menu
  this.app.hideMenu();

  // Show the player with the overlay visible. It will be hidden when the video starts to play
  new TweenMax.set($("#video-player-overlay"), {
    autoAlpha: 1
  });

  new TweenMax.set($("#video-player"), {
    autoAlpha: 1
  });

  new TweenMax.set($("#video-player-wrapper"), {
    zIndex: 100000,
    autoAlpha: 1
  });

  var options = {
    id: id,
    autoplay: false,
    // controls: false,
    byline: false,
    title: false,
    portrait: false,
  };

  if (this.player === false) {
    console.log("Will init Vimeo player");

    // Player not yet initialized, let's do it

    this.player = new Vimeo.Player(this.playerID, options);

    this.player.ready().catch($.proxy(function (e) {
      // Init error, probably a vimeo 403 or 404
      console.log("error-403-404-etc");
      console.log(e);
      this.showPlayer();
    }, this));

    this.player.on("ended", $.proxy(function () {
      // console.log("video ended");

      this.hidePlayer();

      if (callback) {
        callback();
      }

    }, this));


    this.player.on("error", $.proxy(function () {
      console.log("error");
    }, this));

    this.player.on("play", $.proxy(function () {
      // console.log("video play");
      // Video started playing
    }, this));

    this.player.on("bufferend", $.proxy(function () {
      // console.log("video bufferend");
    }, this));

    this.player.on("loaded", $.proxy(function () {
      console.log("video loaded");
      // Video is ready to be played
      this.resize();
      this.showPlayer($.proxy(this.play, this));
    }, this));

  } else {
    // Player already initialized, let's load a new video
    console.log("Use existing Vimeo player. Shouldn't be here anymore.");

    // if (id === this.currentVideoID) {
    //   // Video is ready to be played
    //   console.log("Video is already");
    //
    //   this.player.setCurrentTime(0);
    //   this.resize();
    //
    //   this.showPlayer($.proxy(this.play, this));
    // } else {
    //   console.log("this.player.loadVideo()", options.id);
    //   this.player.loadVideo(options).then($.proxy(function (e) {
    //     console.log(e);
    //     this.showPlayer();
    //     this.player.play();
    //   }, this)).catch($.proxy(function () {
    //     // Init error, probably a vimeo 403 or 404
    //     console.log("error-403-404-etc");
    //     this.showPlayer();
    //   }, this));
    // }
  }

  // this.currentVideoID = id;
}

VimeoVideoPlayer.prototype.showPlayer = function (callback) {
  if (this.timeline != false) {
    this.timeline.kill();
    this.timeline = false;
  }

  this.timeline = new TimelineMax();

  this.timeline.fromTo($("#video-player-overlay"), 1, {
    autoAlpha: 1
  }, {
    autoAlpha: 0
  });

  // Hide main menu
  this.app.hideMenu();

  // Mute main audio
  this.app.audio.mute();

  this.timeline.addCallback(function () {
    $("#video-player-close").addClass("active");

    if (typeof callback === "function") {
      callback();
    }
  });
}

VimeoVideoPlayer.prototype.hidePlayer = function () {
  this.stop();

  $("#video-player-close").removeClass("active");

  if (this.timeline != false) {
    this.timeline.kill();
    this.timeline = false;
  }

  this.timeline = new TimelineMax();

  this.timeline.to($("#video-player"), 1, {
    autoAlpha: 0
  });

  this.timeline.to($("#video-player-wrapper"), 1, {
    autoAlpha: 0
  });

  this.timeline.addCallback($.proxy(function () {
    new TweenMax.set($("#video-player-wrapper"), {
      zIndex: -10
    });

    this.player.destroy().catch(function (error) {
      console.error("An error occured while destroyng the Vimeo Player");
    }).finally($.proxy(function () {
      this.player = false;
    }, this));

    $(this).trigger("videohidden");

  }, this));

  // Mute main audio
  this.app.audio.unmute();

  // Hide main menu
  this.app.showMenu();

}

VimeoVideoPlayer.prototype.play = function () {
  this.player.play();
}

VimeoVideoPlayer.prototype.stop = function () {
  this.player.pause();
}

VimeoVideoPlayer.prototype.resize = function () {
  if (this.player === false || typeof this.player.element === "undefined") {
    return;
  }

  var windowRatio = window.innerWidth / window.innerHeight;

  if (this.playerRatio >= windowRatio) {
    $(this.player.element).width(window.innerWidth)
      .height(window.innerWidth / this.playerRatio);
  } else {
    $(this.player.element).width(window.innerHeight * this.playerRatio)
      .height(window.innerHeight);
  }


}

// Expose VimeoVideoPlayer
window.VimeoVideoPlayer = VimeoVideoPlayer;
